import React, { useEffect } from "react";
import ResusCommande from "../components/CommandeResus/ResusCommande";
import HomeHeader from "../components/homePage/HomeHeader";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
export default function ResusCommand({ paniernbr, acces }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <ResusCommande />
    </>
  );
}
